import { render, staticRenderFns } from "./FormulaDetail.vue?vue&type=template&id=7ae5f792&scoped=true"
import script from "./FormulaDetail.vue?vue&type=script&lang=js"
export * from "./FormulaDetail.vue?vue&type=script&lang=js"
import style0 from "./FormulaDetail.vue?vue&type=style&index=0&id=7ae5f792&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae5f792",
  null
  
)

export default component.exports